﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_footer from './tpl/footer.html';

export default Marionette.LayoutView.extend({
    initialize: function () {
        this.app = this.options.app;
    },
    getTemplate: function () {
        return tpl_footer();
    },
    ui: {
    },
    events: {
    },
    onRender: function () {
    },
    onAttach() {
    }
}, Backbone.Radio.Requests);
